import moment from 'moment-jalaali';

/** Standard Solar Hijri (Zarvāni / Khayyām) month names — 12 months, not Fasli 13-month year. */
export const jalaliMonthNames = [
  { fa: 'فروردین', en: 'Farvardin' },
  { fa: 'اردیبهشت', en: 'Ordibehesht' },
  { fa: 'خرداد', en: 'Khordād' },
  { fa: 'تیر', en: 'Tīr' },
  { fa: 'مرداد', en: 'Amordād' },
  { fa: 'شهریور', en: 'Shahrīvar' },
  { fa: 'مهر', en: 'Mehr' },
  { fa: 'آبان', en: 'Ābān' },
  { fa: 'آذر', en: 'Āzar' },
  { fa: 'دی', en: 'Deī' },
  { fa: 'بهمن', en: 'Bahman' },
  { fa: 'اسفند', en: 'Esfand' },
] as const;

/** Zarvāni month from standard Jalali jMonth (distinct from Fasli zMonth). */
export const jalaliMonth = (date: moment.Moment = moment()) => {
  const jDate = moment(date);
  const monthIndex = jDate.jMonth();
  return {
    month: monthIndex + 1,
    name: jalaliMonthNames[monthIndex],
  };
};
